import React from "react";

import { withIssuesConsumer } from "@adsk/acc-issues-common/components/primitive/IssuesConsumer";
import { Stamp } from "@adsk/acc-issues-common/components/primitive/Stamp";
import { Issue } from "@adsk/acc-issues-types";
import { BlockRemoveButton } from "@adsk/acc-reference-picker";
import Theme from "@adsk/alloy-react-theme";
import { OverflowTooltip } from "@adsk/alloy-react-tooltip";
import styled from "styled-components";

import {
  getIssueUrl,
  useAssigneeName,
  useIssueTypeCode,
} from "./helpers/utils";

const removeButtonClassName = "IssueEntityBlock__remove-button";

const EntityBlockContainer = styled.div`
  cursor: pointer;
  height: 68px;
  padding: 10px 14px 10px 10px;
  display: grid;
  grid-template: "stamp title remove" 27px "stamp details remove" auto / 62px auto 30px;
  &:hover .${removeButtonClassName} {
    visibility: visible;
  }
`;

type IssuesEntityBlockProps = {
  projectId: string;
  entity: Issue;
  onRemoveClick?: () => void;
  onReferenceClickAnalytics?: () => void;
};

export const IssuesEntityBlock = withIssuesConsumer(
  ({
    projectId,
    entity: issue,
    onRemoveClick,
    onReferenceClickAnalytics,
  }: IssuesEntityBlockProps) => {
    const assigneeName = useAssigneeName(issue);

    const issueLabel = `#${issue.displayId} - ${issue.title}`;
    const issueTypeCode = useIssueTypeCode(issue.issueTypeId);

    return (
      <EntityBlockContainer
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onReferenceClickAnalytics && onReferenceClickAnalytics();
          window.open(getIssueUrl({ projectId, issueId: issue.id }));
        }}
      >
        <Stamp size={48} text={issueTypeCode} status={issue.status} />
        <OverflowTooltip
          content={issueLabel}
          singleLine
          getTargetProps={() => ({
            style: { overflow: "hidden", gridArea: "title" },
          })}
        >
          <span style={Theme.typography.bodyMediumBold}>{issueLabel}</span>
        </OverflowTooltip>
        <OverflowTooltip
          content={assigneeName}
          singleLine
          getTargetProps={() => ({
            style: {
              gridArea: "details",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          })}
        >
          {assigneeName}
        </OverflowTooltip>
        {onRemoveClick && (
          <div
            style={{
              alignSelf: "center",
              justifySelf: "end",
              gridArea: "remove",
            }}
          >
            <BlockRemoveButton
              className={removeButtonClassName}
              style={{
                visibility: "hidden",
              }}
              onClick={onRemoveClick}
            />
          </div>
        )}
      </EntityBlockContainer>
    );
  }
);
